import React from 'react';

/**
 * Wraps a component to spread the properties of the "model" prop into the passed in component.
 * @param Component
 * @return {function({model: *, [p: string]: *}): *}
 */
export default function spreadModelProps(Component) {
  // separate the model prop from all other props
  // then spread the model object into the component
  return ({ model, ...props }) => <Component {...model} {...props} />;
}
